import {shortcode_loader} from './shortcodes/loader';
import {detectMedia} from './js/detectMedia';
import {flexText2} from './js/flexText';
import {contactJS} from './js/contact';
import {navigationJS} from './js/navigation';

shortcode_loader();
detectMedia();
flexText2();
contactJS();
navigationJS();
